import { useTranslation } from 'react-i18next'
import { ContactFormFields } from '@customTypes/ContactFormFields'
import prepareBooking from 'src/utils/prepareBooking'
import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import { useCreationEvent } from './useCreationEvent'
import { useGetTreatmentInfo } from './useGetTreatmentInfo'
import { useTreatmentBundleIdForClinic } from './useTreatmentBundleIdForClinic'
import useAdditionalAppointmentHints from './useAdditionalAppointmentHints'

export const usePrepareBooking = () => {
  const choices = useChoiceState()
  const config = useConfig()
  const { sourceWebsiteType } = config
  const lang = useTranslation().i18n.language
  const treatmentInfo = useGetTreatmentInfo()
  const creationEvent = useCreationEvent()
  const treatmentId = useTreatmentBundleIdForClinic()
  const additionalAppointmentHints = useAdditionalAppointmentHints()

  const prepareBookingCallback = (values: ContactFormFields, phoneVerificationCode?: string) => {
    return prepareBooking(
      choices,
      values,
      config,
      lang,
      treatmentInfo.practitioner,
      sourceWebsiteType,
      creationEvent,
      treatmentId,
      phoneVerificationCode,
      additionalAppointmentHints
    )
  }

  return prepareBookingCallback
}
